<template>
  <div id="air_quality_in_urban_ship">
    <div v-if="receivedData.bishkek">
      <SelectGraphic 
        :received-data="receivedData.bishkek"
        id="air_quality_in_urban-bishkek"
      />
    </div>
    <div v-if="receivedData.osh">
      <SelectGraphic 
        :received-data="receivedData.osh"
        id="air_quality_in_urban-osh"
      />
    </div>
  </div>
</template>
<script>
import CMS from '@/model/cms'
import Service from '@/service/service.js'
import { mapGetters } from 'vuex'

export default {
  name: 'AirQualityInUrban',

  components: {
    SelectGraphic: () => import('@/components/graph/SelectGraphic.vue'),
  },

  data () {
    return {
      receivedData: {
        bishkek: null,
        osh: null
      },
      blockId: 'air_quality_in_urban',
      cloneElementId: 'air_quality_in_urban_ship'
    }
  },

  mounted () {
    this.getGraphData()
    Service.elementClone(this.blockId, this.cloneElementId)
  },

  computed: {
    ...mapGetters({
      userToken: 'getUserToken'
    }),
  },

  methods: {
    getGraphData() {
      CMS.getGraph(this.userToken, '6,7,8,9,10,11,12,13,14,15,16,17').then((response) => {
        this.receivedData.bishkek = response.data.slice(0,6)
        this.receivedData.osh = response.data.slice(6)
      })
    }
  }
}
</script>